var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2828",
    "data-name": "Rectangle 2828",
    width: 18,
    height: 18,
    transform: "translate(6.691 6.96)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6517",
    "data-name": "Group 6517",
    transform: "translate(-2.731 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5889",
    "data-name": "Mask Group 5889",
    transform: "translate(-3.96 -3.96)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thumbs",
    transform: "translate(-3.482 0.613)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2829",
    "data-name": "Rectangle 2829",
    width: 2.278,
    height: 2.278,
    transform: "translate(18.04 14.213)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5889-2",
    "data-name": "Mask_Group_5889",
    transform: "translate(12.831 8.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    d: "M82.5,62.454h2.025a1.177,1.177,0,1,0,0-2.354H82.5",
    transform: "translate(-73.017 -52.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    d: "M82.5,80.714h1.936a1.175,1.175,0,0,0,1.177-1.177A.977.977,0,0,0,84.55,78.5",
    transform: "translate(-73.017 -69.006)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    d: "M37.978,10.683c.873,0,2.708.38,2.708-.658A1.175,1.175,0,0,0,39.51,8.848H35.334a12.642,12.642,0,0,0,1.341-3.391,1.481,1.481,0,0,0-.8-1.885,1.267,1.267,0,0,0-1.67.658.617.617,0,0,0-.051.139A13.53,13.53,0,0,1,33.423,6.2a9.667,9.667,0,0,1-1.923,2.2",
    transform: "translate(-28.47 -3.467)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    d: "M10.418,43.1H8.988a1.571,1.571,0,0,0-1.43,1.7v5.5A1.58,1.58,0,0,0,8.988,52h9.288a1.109,1.109,0,0,0,1-1.177.991.991,0,0,0-.949-1.1",
    transform: "translate(-7.552 -38.085)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    d: "M30.5,67.488V63.3",
    transform: "translate(-27.596 -55.729)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/Delivered.68468222c38ae5e9a40a3adb73b48b7e.svg";
export { ForwardRef as ReactComponent };